<template>
  <sui-form-field v-if="!field.hidden">
    <label>{{field.label}}</label>
    <sui-table compact celled size="small" :color="color">
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell :width="6">
            Name
            <span data-inverted data-position="right center" :data-tooltip="field.tooltip" v-show="field.tooltip"><i class="help circle blue icon" /></span>
          </sui-table-header-cell>
          <sui-table-header-cell :width="10">
            Value
          </sui-table-header-cell>
          <sui-table-header-cell collapsing />
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-if="!$attrs.value.length && !field.readonlyVariables">
        <sui-table-row>
          <sui-table-cell colspan="3">
            Empty
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-if="$attrs.value.length">
        <sui-table-row :class="{required: field.fillonly}" v-for="(variable, index) in this.$attrs.value" :key="index">
          <sui-table-cell>
            <input ref="name" v-model="$attrs.value[index].name" :tabindex="field.readonly ? -1 : 0" @input="onInput()" />
          </sui-table-cell>
          <sui-table-cell>
            <div class="env-value">
              <input ref="value" v-model="$attrs.value[index].value" @input="onInput()" />
              <span data-inverted data-position="left center" :data-tooltip="tooltips[variable.name]" v-show="tooltips[variable.name]"><i class="help circle blue icon" /></span>
            </div>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <i class="trash fitted icon" :class="{disabled: field.readonly}" @click.prevent="remove(index)" />
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer v-if="!field.readonly">
        <sui-table-row>
          <sui-table-header-cell colspan="3">
            <div class="ui tiny left labeled icon button" @click.prevent="add()">
              <i class="plus icon" />
              Add
            </div>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormEntityKeyValues',
    mixins: [
      FormField,
    ],
    props: [
      'color',
    ],
    computed: {
      tooltips() {
        return this.entity.comments && this.entity.comments[this.field.name] || {abc: 1}
      },
    },
    methods: {
      add() {
        this.$attrs.value.push({name: '', value: ''})
        this.onInput()
        this.$nextTick(() => {
          this.$refs.name[this.$refs.name.length - 1].focus()
        })
      },
      remove(index) {
        this.$attrs.value.splice(index, 1)
        this.onInput()
      },
    },
  }
</script>

<style scoped>
  .table { margin-top: 0!important; }
  .env-value { display: flex; align-items: center; }
  .trash:hover { color: #c00; cursor: pointer; }
  input[readonly] { opacity: .5; }
  [data-tooltip] { margin-left: .5em; }
</style>
